import { LocalStorageKeys } from 'core/constants/LocalStorageKeys';
import { captureDatadogErrors } from 'core/utils/datadogUtil';

export const setAllCanvasData = (canvasId, data) => {
	try {
		const existingData = localStorage.getItem(LocalStorageKeys.ALL_CANVAS_PREFERENCES);
		const parsedData = existingData ? JSON.parse(existingData) : {};
		parsedData[canvasId] = data;
		localStorage.setItem(LocalStorageKeys.ALL_CANVAS_PREFERENCES, JSON.stringify(parsedData));
	} catch (e) {
		captureDatadogErrors(e, 'Error saving canvas data to local storage');
	}
};

export const getCanvasData = (canvasId) => {
	try {
		const data = localStorage.getItem(LocalStorageKeys.ALL_CANVAS_PREFERENCES);
		const canvasData = JSON.parse(data || '{}');
		return canvasData[canvasId] || null;
	} catch (e) {
		captureDatadogErrors(e, 'Error getting canvas data from local storage');
		return null;
	}
};

export const deleteCanvasData = (canvasId) => {
	try {
		const data = localStorage.getItem(LocalStorageKeys.ALL_CANVAS_PREFERENCES);
		const canvasData = JSON.parse(data || '{}');
		if (canvasData[canvasId]) {
			delete canvasData[canvasId];
			localStorage.setItem(LocalStorageKeys.ALL_CANVAS_PREFERENCES, JSON.stringify(canvasData));
		}
	} catch (e) {
		captureDatadogErrors(e, 'Error deleting canvas data from local storage');
	}
};

export const clearAllCanvasData = () => {
	try {
		localStorage.removeItem(LocalStorageKeys.ALL_CANVAS_PREFERENCES);
	} catch (e) {
		captureDatadogErrors(e, 'Error deleting all canvas data from local storage');
	}
};

export const clearLocalStorage = () => {
	try {
		localStorage.clear();
	} catch (e) {
		captureDatadogErrors(e, 'Error clearing local storage');
	}
};
